<template>
  <Transition name="down">
    <div class="xy-dialog" v-show="props.visible.value">
      <div class="xy-dialog-content">
        <div class="xy-dialog-title">{{ props.title }}</div>
        <div class="xy-dialog-message">{{ props.message }}</div>
        <div class="xy-dialog-check" v-if="checkedText">
          <input type="checkbox" id="confirmCheckbox" v-model="checkValue" />
          <label for="confirmCheckbox"></label>
          <span class="check-label" @click="checkValue = !checkValue">{{ checkedText }}</span>
        </div>
        <div class="xy-dialog-foot">
          <button class="xy-dialog-btn" @click.stop="handleCancel">{{ cancelTxt }}</button>
          <button class="xy-dialog-btn xy-dialog-btn__confirm" @click.stop="handleConfirm">{{ confirmTxt }}</button>
        </div>
      </div>
    </div>
  </Transition>
</template>
<script setup>
import { computed, ref } from 'vue'
import LGSdk from '@/packages/plugins/languageSDK/index'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '标题'
  },
  message: {
    type: String,
    default: '内容'
  },
  confirmText: {
    type: String,
    default: '确认'
  },
  cancelText: {
    type: String,
    default: '取消'
  },
  checkedText: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['cancel', 'confirm'])
const checkValue = ref(false)

const confirmTxt = computed(() => {
  return props.confirmText ? props.confirmText : LGSdk.t('public.confirm')
})

const cancelTxt = computed(() => {
  return props.cancelText ? props.cancelText : LGSdk.t('public.cancel')
})

const handleCancel = () => {
  emit('cancel')
}

const handleConfirm = () => {
  emit('confirm', checkValue.value)
}
</script>
<style scoped lang="scss">
.xy-dialog {
  z-index: 9989;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  .xy-dialog-content {
    color: #fff;
    font-size: 0.75rem;
    width: 20rem;
    overflow: hidden;
    border-radius: 0.75rem;
    background-color: #fff;
    color: #323233;
    .xy-dialog-title {
      padding-top: 1.625rem;
      font-weight: 500;
      line-height: 1.5rem;
      text-align: center;
      font-size: 1rem;
    }
    .xy-dialog-message {
      max-height: 60vh;
      padding: 1.625rem 1.5rem;
      overflow-y: auto;
      font-size: 0.875rem;
      line-height: 1.25rem;
      white-space: pre-wrap;
      text-align: center;
      word-wrap: break-word;
      padding-top: 0.5rem;
      color: #646566;
    }
    .xy-dialog-foot {
      position: relative;
      display: flex;
      .xy-dialog-btn {
        flex: 1;
        height: 3rem;
        margin: 0;
        border: 0;
        position: relative;
        display: inline-block;
        box-sizing: border-box;
        padding: 0;
        font-size: 1rem;
        line-height: 1.2;
        text-align: center;
        border-radius: 0.125rem;
        cursor: pointer;
        transition: opacity 0.2s;
        color: #323233;
        background-color: #fff;
      }
      .xy-dialog-btn:active {
        background-color: #f4f4f5;
      }
      .xy-dialog-btn__confirm {
        color: #409eff;
      }
      .xy-dialog-btn__confirm::after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        top: -50%;
        right: -50%;
        bottom: -50%;
        left: -50%;
        border: 1px solid #ebedf0;
        transform: scale(0.5);
      }
    }
    .xy-dialog-foot::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      top: -50%;
      right: -50%;
      bottom: -50%;
      left: -50%;
      border: 0.0625rem solid #ebedf0;
      transform: scale(0.5);
    }
  }
}
.down-enter-from {
  opacity: 0;
}
.down-enter-active {
  transition: all 0.5s;
}
.down-enter-to {
  opacity: 1;
}

@keyframes rotateAnimation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rotate-element {
  animation: rotateAnimation 2s linear infinite;
}

.xy-dialog-check {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
  .check-label {
    color: #646566;
  }
  #confirmCheckbox {
    display: none;
  }
  #confirmCheckbox + label::before {
    content: '';
    display: inline-block;
    width: 0.8125rem;
    height: 0.8125rem;
    margin-right: 0.5rem;
    background: transparent; /* 默认背景颜色 */
    border-radius: 0.1875rem; /* 圆角 */
    vertical-align: middle;
    border: 0.0625rem solid #409eff;
  }

  /* 当复选框被选中时改变背景和添加勾选符号 */
  #confirmCheckbox:checked + label::before {
    background: #409eff; /* 选中时的背景颜色 */
    content: '✓';
    color: white; /* 勾选符号颜色 */
    font-size: 1rem;
    text-align: center;
    line-height: 0.8125rem; /* 调整勾选符号的位置 */
  }
}
</style>
